import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = ({ component: Component, authed, ...rest }) => {
     return <Route {...rest} render={(routeProps) => (authed === true ? <Component {...routeProps} /> : <Redirect to={"/login"} />)} />;
};

export default PrivateRoute;
